import React from "react";
import { Helmet } from "react-helmet";

const Disclaimer = () => {
  return (
    <div className="page-container">
      <Helmet>
        <title>Disclaimer | AAMSchool</title>
        <link rel="canonical" href="https://www.aamschool.in/disclaimer" />
        <meta
          name="description"
          content="Read the AAMSchool Disclaimer to understand the informational nature of our content and the need to verify final details from official sources."
        />
        <meta property="og:title" content="Disclaimer | AAMSchool" />
        <meta
          property="og:description"
          content="Read the AAMSchool Disclaimer to understand the informational nature of our content and the need to verify final details from official sources."
        />
        <meta property="og:url" content="https://www.aamschool.in/disclaimer" />
        <meta property="og:type" content="website" />
      </Helmet>
      <h1>Disclaimer</h1>
      <p className="page-lead">
        AAMSchool Naukari publishes informational content to help users discover education and job
        related updates more easily, but it is not an official authority.
      </p>

      <section className="page-policy-section">
        <h2>Independent Platform</h2>
        <p>
          AAMSchool Naukari is not a government website and is not affiliated with any government
          organization. All information on this website is published for educational and
          informational purposes only.
        </p>
      </section>

      <section className="page-policy-section">
        <h2>Accuracy and Verification</h2>
        <p>
          We try to collect information from official websites and trusted sources, but we do not
          guarantee absolute accuracy or completeness. Users must always verify final details from
          the official website before applying, paying fees, downloading documents, or taking any
          decision based on a post.
        </p>
        <p>
          Job notifications, result links, admit card notices, syllabus details, exam dates, and
          admission instructions may change without prior notice by the concerned authority. The
          official website should always be treated as the final and controlling source.
        </p>
      </section>

      <section className="page-policy-section">
        <h2>Learning Content</h2>
        <p>
          The preparation-related content on this site, including quizzes, syllabus support, and
          study guidance, is meant to support learning and revision. It should not be treated as a
          substitute for official syllabus documents, recruitment rules, or institutional
          announcements.
        </p>
      </section>

      <section className="page-policy-section">
        <h2>Limitation of Responsibility</h2>
        <p>
          We are not responsible for any loss, delay, or damage arising from the use of information
          published on this website. Users are responsible for verifying and using information with
          proper care.
        </p>
      </section>
    </div>
  );
};

export default Disclaimer;
